import axios from "axios";

const uploads = {

    /**
     *
     * @param {File} file
     * @param {String} path
     * @param {Object|null} config
     * @returns {Promise<any>}
     */
    async store(file, path = '', config = null){
        const data = new FormData();
        data.append('file', file);
        data.append('path', path);
        return (await axios.post('/api/file/upload', data, config)).data;
    }

}

export default uploads;
